/**
 * mahitab-colour-siblings.js                                     [CRO edits]
 *
 * The colour row under the product title (the audit's P2).
 *
 * Mahitab does not use Shopify variants - every colour is its own product - so
 * a product page shows one shade and, until now, offered no route to the other
 * 29. This finds the siblings at runtime by searching the colour-stripped
 * title through templates/search.siblings.liquid, then filters the results
 * back down to products whose stripped title matches exactly.
 *
 * TWO KINDS OF GROUP, measured across all 13,148 products:
 *   282 groups have differing titles  -> real colours, each with a name
 *        ("جيب بنطلون كريب" in 30 named shades). Rendered as labelled swatches.
 *   331 groups have IDENTICAL titles  -> distinct prints with no name at all
 *        (391 products all called "بلوزة فيسكوز بيور"). There is no colour to
 *        label, so these render as an unlabelled image row with a different
 *        heading. Treating both the same would produce a "colour selector"
 *        listing 391 nameless entries.
 *
 * Sold-out siblings are shown greyed rather than hidden: the size of the
 * colour range is the selling point, and a greyed swatch still communicates it.
 *
 * No catalogue data is written. The alternative (a list.product_reference
 * metafield per product) would mean ~12,800 writes and a rewrite on every
 * catalogue change.
 */
(function () {
  'use strict';

  var MAX = 24;          // rendered swatches before the "view all" link
  var THUMB = 200;       // px requested from the CDN

  function norm(s) {
    if (!s) return '';
    return String(s)
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Strip colour words -> the key that groups siblings. Mirrors
  // snippets/mahitab-dedupe-key.liquid, sharing its lexicon.
  function baseKey(title, colours) {
    var words = norm(title).split(' ');
    var kept = [];
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (w && colours.indexOf(w) === -1) kept.push(w);
    }
    return kept.join(' ').trim();
  }

  // Whatever the title has that the base key does not, in original order.
  function colourLabel(title, colours) {
    var words = norm(title).split(' ');
    var dropped = [];
    for (var i = 0; i < words.length; i++) {
      if (words[i] && colours.indexOf(words[i]) !== -1) dropped.push(words[i]);
    }
    return dropped.join(' ');
  }

  function init() {
    var root = document.querySelector('[data-mhb-colours]');
    if (!root) return;

    var title = root.getAttribute('data-title') || '';
    var currentId = root.getAttribute('data-product-id') || '';
    var colours = (root.getAttribute('data-lexicon') || '').split(',')
      .map(function (c) { return norm(c); }).filter(Boolean);

    var key = baseKey(title, colours);
    if (!key) return;

    // Printed fabrics whose title ENDS in the print word are the nameless
    // ones - "قماش فيسكوز بيور مشجر" is 1,197 products sharing that exact
    // title, every one a different design. There is no colourway set to
    // offer, so the row is suppressed.
    //
    // Matched on the LAST word only, deliberately: "قماش فيسكوز بيور مشجر اسود"
    // and "… مشجر كحلي" name a colour after the print and do have real
    // siblings, so they keep their row.
    var excluded = (root.getAttribute('data-exclude') || '')
      .split(',').map(function (t) { return norm(t); }).filter(Boolean);
    var lastWord = norm(title).split(' ').pop();
    if (excluded.indexOf(lastWord) !== -1) return;

    var url = '/search?type=product&view=siblings&q=' + encodeURIComponent(key);
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var all = (data.products || []).filter(function (p) {
          return baseKey(p.title, colours) === key;
        });
        if (all.length < 2) return;               // nothing to switch between

        // Identical titles across the group => prints, not named colours.
        var distinct = {};
        all.forEach(function (p) { distinct[norm(p.title)] = 1; });
        var labelled = Object.keys(distinct).length > 1;

        render(root, all, currentId, colours, labelled, key);
      })
      .catch(function () { /* leave the block empty; the page is unaffected */ });
  }

  function render(root, items, currentId, colours, labelled, key) {
    // Current product first, then in-stock, so the row opens on something buyable.
    items.sort(function (a, b) {
      if (String(a.id) === String(currentId)) return -1;
      if (String(b.id) === String(currentId)) return 1;
      return (b.available === true) - (a.available === true);
    });

    var shown = items.slice(0, MAX);
    var frag = document.createDocumentFragment();

    shown.forEach(function (p) {
      var isCurrent = String(p.id) === String(currentId);
      var a = document.createElement('a');
      a.className = 'mhb-cs__item' + (isCurrent ? ' is-current' : '') +
                    (p.available === false ? ' is-soldout' : '');
      a.href = p.url;
      if (isCurrent) a.setAttribute('aria-current', 'true');

      var label = labelled ? colourLabel(p.title, colours) : '';
      a.title = label ? p.title : p.title;

      if (p.image) {
        var img = document.createElement('img');
        img.className = 'mhb-cs__img';
        img.src = p.image;
        img.alt = label || p.title;
        img.width = 52; img.height = 52;
        img.loading = 'lazy'; img.decoding = 'async';
        a.appendChild(img);
      }
      if (labelled && label) {
        var span = document.createElement('span');
        span.className = 'mhb-cs__label';
        span.textContent = label;
        a.appendChild(span);
      }
      frag.appendChild(a);
    });

    var head = root.querySelector('[data-mhb-colours-head]');
    var count = root.querySelector('[data-mhb-colours-count]');
    var strip = root.querySelector('[data-mhb-colours-strip]');
    var more = root.querySelector('[data-mhb-colours-more]');

    if (head) head.textContent = labelled ? root.getAttribute('data-label-colours')
                                          : root.getAttribute('data-label-designs');
    if (count) count.textContent = '(' + items.length + ')';
    if (strip) { strip.innerHTML = ''; strip.appendChild(frag); }
    if (more) {
      // Always offer the route to the full set. Search relevance caps what we
      // can see - an identical-title group of 391 only surfaces ~10 here - so
      // hiding this link when the fetched list happens to fit would strand the
      // shopper on a fraction of the range.
      more.href = '/search?type=product&q=' + encodeURIComponent(key);
      more.hidden = false;
    }
    root.hidden = false;

    var active = root.querySelector('.is-current');
    if (active && active.scrollIntoView) {
      try { active.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
    }
  }

  // Exposed so mahitab-pdp-swap.js can re-bind the row after it replaces the
  // product section in place - this script's own entry point below only fires
  // on DOMContentLoaded, which never happens again after a swap.
  window.MahitabColourSiblings = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
